<template>
  <!--<p>Configure your site configuring <strong>Nodes</strong> for 4 screens, visible in the realtime monitor. Main and common nodes can be enabled or disabled. Some of the main nodes are common and shared between screens (such as Grid, Grouped Load, and DC Inverter).</p>
  <p>Detailled Nodes are available to show a better representation of the network installed, nodes can be DERs (generators or storage, AC or DC coupled) or LOADS, there are subtypes like EV-chargers, batteries or PV.</p>-->
 
  <div :class="{'warning-icon':(!isMyUserAdmin)}" />

  <DxTabPanel 
    :items="screenList"
    :animation-enabled="false" 
    :swipe-enabled="false"
    v-model:selected-index="selectedScreen">
  </DxTabPanel>
  
  <div :class="{'disabled-overlay':(!isMyUserAdmin)}">
  <DxDataGrid
    ref="datagridRef"
    :data-source="mainNodesDataSource"
    :visible="(selectedScreen==0)"
    :show-borders="true"
    :column-hiding-enabled="true"
    @saved="saveChanges"
    >
    <DxSelection mode="single" />
    <DxEditing :allow-updating="true" mode="batch" />
    <!--DxColumn data-field="id" :width="80" :hiding-priority="1" data-type="number" :allow-editing="false" /-->
    <DxColumn data-field="node" :hiding-priority="4" caption="Node Type" :min-width="120" :lookup="{dataSource: nodeFamiliesArr['MAIN_GROUP'], valueExpr:'id', displayExpr:'type' }" :allow-editing="false" />
    <DxColumn data-field="caption" caption="Node Name" :min-width="80" />
    <DxColumn data-field="enabled" data-type="boolean" :width="70" key=""/>
    <DxColumn data-field="showKpiWindow" caption="Show KPI Window"  data-type="boolean" :width="70" />
    <!-- <DxColumn data-field="asset_id" caption="Asset" :min-width="120" :hiding-priority="6" :lookup="{dataSource: assetDS, valueExpr:'id', displayExpr:'name'}"/> -->
    <DxColumn data-field="asset_id" caption="Asset" :min-width="100" :hiding-priority="6" alignment="left" edit-cell-template="editcellTemplate_as" cell-template="cellTemplate_as" :set-cell-value="void_signals_ids"/>
    <template #cellTemplate_as="{ data }">
        {{ get_asset_name(data) }}
      </template>
      <template #editcellTemplate_as="{ data }">
        <DxSelectBox
          :show-clear-button="true"
          v-model:value="data.value"
          :data-source="assetDS"
          value-expr="id"
          display-expr="name"
          @value-changed="asset_edited(data)"
        />
      </template>
    <DxColumn data-field="signal1_id" caption="Signal 1" :hiding-priority="5" :min-width="150" alignment="left" edit-cell-template="editcellTemplate1" cell-template="cellTemplate" />
    <DxColumn data-field="signal2_id" caption="Signal 2" :hiding-priority="4" :min-width="150" alignment="left" edit-cell-template="editcellTemplate2" cell-template="cellTemplate"/>
    <DxColumn data-field="signal3_id" caption="Signal 3" :hiding-priority="3" :min-width="150" alignment="left" edit-cell-template="editcellTemplate3" cell-template="cellTemplate" /> 
    <DxColumn data-field="gpsLat" caption="GPS Latitude" data-type="number" :hiding-priority="2" :width="90" :editor-options="{ min: -90, max: 90 }" />
    <DxColumn data-field="gpsLng" caption="GPS Longitude" data-type="number" :hiding-priority="1" :width="90" :editor-options="{ min: -180, max: 180 }"/>
    <DxColumn data-field="description" :hiding-priority="0" />
      <template #cellTemplate="{ data }">
        {{ get_signal_name(data) }}
      </template>
      <template #editcellTemplate1="{ data }">
        <DxSelectBox
          :show-clear-button="true"
          v-model:value="data.value"
          :data-source="edit_signal_list(data)"
          value-expr="signalId"
          display-expr="name"
          @value-changed="signal_edited(data)"
        />
      </template>
      <template #editcellTemplate2="{ data }">
        <DxSelectBox
          :show-clear-button="true"
          v-model:value="data.value"
          :data-source="edit_signal_list(data)"
          value-expr="signalId"
          display-expr="name"
          @value-changed="signal_edited(data)"
        />
      </template>
      <template #editcellTemplate3="{ data }">
        <DxSelectBox
          :show-clear-button="true"
          v-model:value="data.value"
          :data-source="edit_signal_list(data)"
          value-expr="signalId"
          display-expr="name"
          @value-changed="signal_edited(data)"
        />
      </template>
   
  </DxDataGrid>
   
  
    <DxDataGrid
      :data-source="graphViewDS"
      :visible="(selectedScreen==1)"
      :show-borders="true"
      :column-hiding-enabled="true"
      >
      <DxEditing :allow-updating="true" :allow-adding="true" :allow-removing="true"  mode="batch" />
      <DxRowDragging
        :allow-reordering="false"
      />
      <DxColumn data-field="order" data-type="number" width="90"/>
      <DxColumn data-field="title" caption="Graphic title"  width="300"/>
      <DxColumn data-field="graph_type" caption="Graphic type" width="100">
        <DxLookup :data-source="[{text:'line'}]" display-expr="text" value-expr="text"/>
      </DxColumn>
      <DxColumn data-field="signals" cell-template="chooseGraphics" :allow-editing="false"  />
      <template #chooseGraphics="{ data }">
        {{ data.value }}
        <DxButton @click="openPopupSelectGraphs(data)" icon="edit"/>
      </template>
    </DxDataGrid>

  </div>

  <DxPopup
    title="Signals"
    v-model:visible="isCalendarPopupOpen"
    :hide-on-outside-click="true"
    height="600px"
    width="800px"
  >
      <div style="padding:0 11px;">
       <DxTagBox 
          ref="tagBoxGraphs"
          v-model:value="selectedGraphics" 
          :data-source="signalsData"
          :search-enabled="false"
          :open-on-field-click="false"
          value-expr="id"
          display-expr="name"
          search-expr="name"
          width="100%"
          :on-selection-changed="graphSelectionChangedTag"
          styling-mode="underlined"
          :hover-state-enabled="false"
          placeholder="Select the signals from the table"
          >
          <DxValidator>
              <DxCustomRule 
                message="The maximum number of selectable signals is 5" 
                :validation-callback="()=>{return selectedGraphics.length<=5}"/>
          </DxValidator>
        </DxTagBox>
      </div>
      <DxDataGrid
        :data-source="signalsData"
        :search-panel="{visible:true, width:'300'}"
        :selection="{mode:'multiple',showCheckBoxesMode:'always',allowSelectAll:false}"
        :grouping="{autoExpandAll:false,expandMode:'rowClick'}"
        :paging="{pageSize:9}"
        :pager="{visibled:true,displayMode:'full',showPageSizeSelector:false,showInfo:false,
        showNavigationButtons:true}"
        :on-selection-changed="graphSelectionChanged"
        v-model:selected-row-keys="selectedGraphicsId"
        >
        <DxColumn
          data-field="name"/>
          
        <DxColumn
          data-field="asset"
          :group-index="0"/>
        <DxToolbar> 
          <DxItem
            location="after"
            name="searchPanel"
          />
          <DxItem
            location="before"
            template="saveButton"
          />
        </DxToolbar>

        <template #saveButton>
          <DxButton :on-click="saveSignals"
            styling-mode="outlined" 
            icon="save" 
            width="150"
            text="Save"/>
        </template>
      </DxDataGrid>
  </DxPopup>

  
  <div class="row justify-content-center mt-3">
    <div :class="cssClassMainImg">
      <h4 class="text-secondary text-center">Main Group Layout</h4>
      <canvas ref="canvas_MAIN_GROUP" ></canvas>
    </div>
    <div :class="cssClassDerAcImg">
      <h4 class="text-secondary text-center">AC Coupled DERs</h4>
      <canvas ref="canvas_DER_AC" ></canvas>
    </div>
    <div :class="cssClassDerDcImg">
      <h4 class="text-secondary text-center">DC Coupled DERs</h4>
      <canvas ref="canvas_DER_DC" ></canvas>
    </div>
    <div :class="cssClassDerLoadImg">
      <h4 class="text-secondary text-center">Load Details Layout</h4>
      <canvas ref="canvas_LOADS" ></canvas>
    </div>
    <!--<div :class="cssClassBattImg">
      <h4 class="text-secondary text-center">Battery Details Layout</h4>
      <canvas ref="canvas_BATT" ></canvas>
    </div>-->
  </div>



</template>

<script>
import { ref, reactive, onMounted, computed } from 'vue';
import DxDataGrid, { 
  DxSelection,
  DxEditing,
  DxRowDragging,
  DxColumn,
  DxToolbar,
  DxItem,
  DxLookup,
} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTabPanel from "devextreme-vue/tab-panel";
import { DxPopup } from 'devextreme-vue/popup';
import RawDataService from '../services/RawDataServiceTemplate';
import DataService from '../services/DataServiceTemplate';
import notify from 'devextreme/ui/notify';
import * as PIXI from 'pixi.js'
import { attachGraphics, buildGraphsMap } from '../utils/realtime-canvas.js';
import { useStore } from 'vuex';
import DxTagBox from 'devextreme-vue/tag-box';
import {
    DxValidator,
    DxCustomRule
} from 'devextreme-vue/validator';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
export default {
  components: {
    DxDataGrid,
    DxSelection,
    DxEditing,
    DxRowDragging,
    DxColumn,
    DxToolbar,
    DxItem,
    DxLookup,
    DxSelectBox,
    DxTabPanel,
    DxPopup,
    DxButton,
    DxTagBox,
    DxValidator,
    DxCustomRule,
  },
  setup() {
    // Validate permissions
    const store = useStore()
    const DEF_AUTHCODES = { web:1, admon:100, iot:120 };
    const isMyUserAdmin = store.getters.hasAdminAccess(DEF_AUTHCODES.admon)

    //
    const screenList = [
      { ctrId: 'MAIN_GROUP', title:'General View' },
      { ctrId: 'GRAPH_VIEW', title:'Graphic View'}
    ];
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const staticTablesDataService = new RawDataService('statics/tables');
    const fullNodesDS = new RawDataService('masters/enfyoGraphNodes');
  
    const assetDS = ref([]);
    const signals = ref([]);
    const datagridRef = ref()
    const edit_signal_list = (data)=>{
      const selected_asset = assetDS.value.find(as=> as.id==data.data.asset_id) || {}
      const newDS = signals.value.filter(sig => sig.assetName==selected_asset.name && sig.name!='sig0');

      if (data.value!=null && !newDS.find(s=> s.signalId==data.value)){
        data.setValue(null,'')
      }
      return newDS
    }
    const get_signal_name = (id)=>{
      return signals.value.find(sig => sig.signalId==id.value)?.name || ''
    }
    const signal_edited=(data)=>{
      data.setValue(data.value,"")
    }


    const get_asset_name = (id)=>{
      return assetDS.value.find(sig => sig.id==id.value)?.name || ''
    }
    const asset_edited=(data)=>{
      data.setValue(data.value,"")
    }
    const void_signals_ids = (newData, value,currentData)=>{
      newData.asset_id=value
      if (currentData.signal1_id!=null) newData.signal1_id=null
      if (currentData.signal2_id!=null) newData.signal2_id=null
      if (currentData.signal3_id!=null) newData.signal3_id=null
      
      datagridRef.value.instance.refresh()
    }

    const nodesDSObjs = {
      MAIN_GROUP: new DataService('masters/enfyoGraphNodes', 'id'),
      DER_AC: new DataService('masters/enfyoGraphNodes', 'id'),
      DER_DC: new DataService('masters/enfyoGraphNodes', 'id'),
      LOADS: new DataService('masters/enfyoGraphNodes', 'id'),
      BUS: new DataService('masters/enfyoGraphNodes', 'id'),
      //BATT: new DataService('masters/enfyoGraphNodes', 'id'),
    }
    nodesDSObjs.MAIN_GROUP.setFilter({ scrFilter: 'MAIN_GROUP' });
    nodesDSObjs.DER_AC.setFilter({ scrFilter: 'DER_AC' });
    nodesDSObjs.DER_DC.setFilter({ scrFilter: 'DER_DC' });
    nodesDSObjs.LOADS.setFilter({ scrFilter: 'LOADS' });
    nodesDSObjs.BUS.setFilter({ scrFilter: 'BUS' });
    //nodesDSObjs.BATT.setFilter({ scrFilter: 'BATT' });



    const mainNodesDS = new DataService('masters/enfyoGraphNodes', 'id');
    //const detailsNodesDS = new DataService('masters/enfyoGraphNodes', 'id');
    const detailNodesDataSource = ref(nodesDSObjs.DER_AC.dataSource);
    mainNodesDS.setFilter({ scrFilter: 'MAIN_GROUP' })
    //detailsNodesDS.setFilter({ scrFilter: 'DETAIL_GROUPS' })
    

    const getGraphNodeFamiliesPr = staticTablesDataService.getByKey('graphNodeFamilies');
    getGraphNodeFamiliesPr.then(nFamList => {
      for(const nodeScreen in nodeFamiliesArr){
        nodeFamiliesArr[nodeScreen] = nFamList.filter(fam => fam.screen_id==nodeScreen);
      }
      nodeFamilyFiltArr.value=nodeFamiliesArr.DER_AC; //default filtyered list
    }).catch(stErrorCb);


    const nodeFamiliesArr = reactive({
      MAIN_GROUP: [],
      DER_AC: [],
      DER_DC: [],
      LOADS: [],
      BUS: [],
     // BATT: [],
    });
    const enabledScreens = reactive({
      MAIN_GROUP: false,
      DER_AC: false,
      DER_DC: false,
      LOADS: false,
      BUS: false,
      //BATT: false,
    });
    const selectedScreen = ref(0);
    const nodeFamilyFiltArr = ref([]);


    /** @type {{ MAIN_GROUP:PIXI.Application, DER_DC:PIXI.Application, DER_AC:PIXI.Application, LOADS:PIXI.Application }} */
    const pixiApps = {}; // object containing PIXI apps (graphic screens)
    
    const canvas_MAIN_GROUP = ref(null);
    const canvas_DER_AC = ref(null);
    const canvas_DER_DC = ref(null);
    const canvas_LOADS = ref(null);
    const canvas_BUS = ref(null);
    const canvas_BATT = ref(null);
    
    const canvasObjSelector = (screenName) => {
      if(screenName=='MAIN_GROUP') return canvas_MAIN_GROUP;
      if(screenName=='DER_AC') return canvas_DER_AC;
      if(screenName=='DER_DC') return canvas_DER_DC;
      if(screenName=='LOADS') return canvas_LOADS;
      if(screenName=='BUS') return canvas_BUS;
      if(screenName=='BATT') return canvas_BATT;
    }
    const canvasSelector = (screenName) => {
      return canvasObjSelector(screenName).value;
    }

    const buildGraphics = async() => {
      try{
        //fecth data from dataservices
        const nodeFamilies = await getGraphNodeFamiliesPr; // full node families table
        const graphNodes = await fullNodesDS.getAll();
        if(!graphNodes.length) throw new Error('no nodes to graph, please enable nodes')
        graphNodes.map(sysNode => { 
          sysNode.NodeType = nodeFamilies.find (nt => nt.id == sysNode.node);
          return sysNode;
        });

        //build screens map with embeeded graphic nodes
        const screenNodesMap = buildGraphsMap(graphNodes);
        //create graphic elements for nodes 
        const cvProps = await attachGraphics(screenNodesMap);
        
        // create and draw canvas graphics
        for(const scr in enabledScreens)  //clean flags
          enabledScreens[scr]=false;
        for(const [screnName, screnNodes] of screenNodesMap){ //create screens and graphics
          enabledScreens[screnName] = true;
          pixiApps[screnName]?.destroy?.();
          pixiApps[screnName] = new PIXI.Application({
            antialias: false,
            width: 3280,
            height: cvProps[screnName].canvasHeight,
            backgroundColor: 0xfefefe,
            backgroundAlpha: 1,
            view: canvasSelector(screnName),
          }); 
          pixiApps[screnName].stage.sortableChildren = true;
          pixiApps[screnName].view.style.width = '100%';
         
          for(const node of screnNodes){ // draw graphic elements
            if(!node.graphics) continue;
            for(const [, graphEl] of node.graphics){
              pixiApps[screnName].stage.addChild(graphEl);
            }
          }
          pixiApps[screnName].render();
         
        }
      }catch(err){ notify(err.message, 'error', 4000) }
    }

    // Graphic view
    const isCalendarPopupOpen= ref(false)
    const selectedGraphics = ref([])
    const selectedGraphicsId =ref([])
    const cellObj = ref([])
    const graphSelectionChanged = (e)=>{
      selectedGraphics.value=e.selectedRowsData
    }
    const graphSelectionChangedTag = ()=>{
      
      if(selectedGraphicsId.value.length>selectedGraphics.value.length){
        selectedGraphicsId.value.forEach(sig=>{
          if(!selectedGraphics.value.find(s=>s.id==sig)){
            selectedGraphicsId.value=selectedGraphicsId.value.filter(s=>s!=sig)
          }
        })
      }
    }
    const graphicsDataService = new RawDataService('masters/graphicView');
    const signalDataService = new RawDataService('masters/signals', 'signalId') 
    const signalsData = new DataSource({
      store: new CustomStore({
        key: 'id',
        load: async()=>{
          const data = await signalDataService.getAll()
          const newDs=[]
          for(var sig of data){
            newDs.push({
              id:sig.signalId,
              name: sig.name,
              asset: sig.assetName,
            })
          }
          return newDs
        },
      }),
      paginate:false
    })


    const graphViewStore = new CustomStore({
      key: 'id',
      loadMode: "raw",
      load: async() => {
        try{
          let newDs = [];
          const signalList = await signalDataService.getAll()
          const graphicList = await graphicsDataService.getAll()
          for(var graph of graphicList){
            const signals = signalList.filter(s=>[graph.signal1_id,graph.signal2_id,graph.signal3_id,graph.signal4_id,graph.signal5_id].includes(s.signalId))
            var signals_name = ''
            for(var sig of signals){
              signals_name=signals_name+sig.name+'; '
            }
            newDs.push({
              id: graph.id,
              title: graph.title,
              order: graph.order,
              graph_type: graph.graph_type,
              signals: signals_name,
              signal1_id: graph.signal1_id,
              signal2_id: graph.signal2_id,
              signal3_id: graph.signal3_id,
              signal4_id: graph.signal4_id,
              signal5_id: graph.signal5_id
            })
          }
          return newDs;
        }catch(err) { notify('error: '+err.message, 'error', 4000); return [] }
      },
      insert: async(data) => {
        try{
          await graphicsDataService.create(data).then(res=> {
            if(res.isOk) notify('Updated graphics settings', 'success', 4000)
          })
        }
        catch(error){ stErrorCb(error); }
      },
      update: async(key, data) => {
        try{
          await graphicsDataService.update(key,data).then(res=> {
            if(res.isOk) notify('Updated graphics settings', 'success', 4000)
          })
        }catch(err){stErrorCb(err)}
      },
      remove: async(key) => {
        try{
          await graphicsDataService.remove(key).then(res=> {
            if(res.isOk) notify('Updated graphics settings', 'success', 4000)
          })
        }catch(err){stErrorCb(err)}
      }

    })
   
    const graphViewDS = new DataSource({
      store: graphViewStore,
      paginate: false,
      sort:"order"
    }); 

    
    const tagBoxGraphs = ref()
    const openPopupSelectGraphs = async (data)=>{
      cellObj.value=data
      await tagBoxGraphs.value.instance.reset()
      selectedGraphics.value=[]
      selectedGraphicsId.value=[]
      const signalList = signals.value.filter(s=>[data.data.signal1_id,data.data.signal2_id,
        data.data.signal3_id,data.data.signal4_id,data.data.signal5_id].includes(s.signalId))
      
      for(var sig of signalList){
        selectedGraphics.value.push(sig)
        selectedGraphicsId.value.push(sig.signalId)
      }
      await tagBoxGraphs.value.instance.repaint()
      isCalendarPopupOpen.value=true; 
    }

    const saveSignals = async ()=>{
        cellObj.value.data.signal1_id=selectedGraphicsId.value[0]||null
        cellObj.value.data.signal2_id=selectedGraphicsId.value[1]||null
        cellObj.value.data.signal3_id=selectedGraphicsId.value[2]||null
        cellObj.value.data.signal4_id=selectedGraphicsId.value[3]||null
        cellObj.value.data.signal5_id=selectedGraphicsId.value[4]||null
      
        await graphViewStore.update(cellObj.value.data.id,cellObj.value.data).then(res=> {
            if(res.isOk) notify('Updated graphics settings', 'success', 4000)
          })
        isCalendarPopupOpen.value=false; 
       
        cellObj.value.component.refresh()
    }

    
    //
    onMounted(async () => {
      buildGraphics();

      const assetDataService = new RawDataService('masters/assets', 'id')  
      assetDS.value = await assetDataService.getAll();  
      signals.value = await signalDataService.getAll();
    });

    const cssClassMainImg = computed(() => { return (enabledScreens.MAIN_GROUP && selectedScreen.value==0)?'col-md-12 col-lg-6': 'col-md-12 col-lg-6 d-none'; });
    const cssClassDerAcImg = computed(() => { return (enabledScreens.DER_AC && selectedScreen.value==1)?'col-md-12 col-lg-6': 'col-md-12 col-lg-6 d-none'; });
    const cssClassDerDcImg = computed(() => { return (enabledScreens.DER_DC && selectedScreen.value==2)?'col-md-12 col-lg-6': 'col-md-12 col-lg-6 d-none'; });
    const cssClassDerLoadImg = computed(() => { return (enabledScreens.LOADS && selectedScreen.value==3)?'col-md-12 col-lg-6': 'col-md-12 col-lg-6 d-none'; });
    //const cssClassBattImg = computed(() => { return (enabledScreens.BATT && selectedScreen.value==4)?'col-md-12 col-lg-6': 'col-md-12 col-lg-6 d-none'; })

    const saveChanges = async () => {
      try{
        notify("changes saved in server", "success", 4000);
        await buildGraphics();
      }catch(error){ stErrorCb(error); }
    }

    /** update table shown according to detail screen selected */
    const screenChanged = (e) => {
      const screenName = e.addedItems[0].ctrId;
      
      nodeFamilyFiltArr.value=nodeFamiliesArr[screenName];
      detailNodesDataSource.value = nodesDSObjs[screenName].dataSource;
    }

    return {
      isMyUserAdmin,
      canvas_MAIN_GROUP,
      canvas_DER_AC,
      canvas_DER_DC,
      canvas_LOADS,
      //canvas_BATT,
      screenList,
      enabledScreens,
      selectedScreen,
      cssClassMainImg,
      cssClassDerAcImg,
      cssClassDerDcImg,
      cssClassDerLoadImg,
     // cssClassBattImg,
      
      nodeFamiliesArr,
      nodeFamilyFiltArr,
      
      mainNodesDataSource: mainNodesDS.dataSource,
      detailNodesDataSource,

      saveChanges,
      screenChanged,
      assetDS,
      signals,
      edit_signal_list,
      get_signal_name,
      signal_edited,
      
      get_asset_name,
      asset_edited,
      void_signals_ids,
      datagridRef,

      graphViewDS,
      signalsData,
      isCalendarPopupOpen,
      selectedGraphics,
      selectedGraphicsId,
      graphSelectionChanged,
      graphSelectionChangedTag,
      saveSignals,
      cellObj,
      tagBoxGraphs,
      openPopupSelectGraphs,
    }
  },
}
</script>

<style>
@import url('../themes/base.scss');

</style>
